import * as ACTIONS from "./../actions/actionConstants";

const initialState = {
  data: {},
  weather: {
    key: "3186cb735a358098084a4f92a6042f27",
    data: {
      main: {
        temp: "err",
        temp_min: "err",
        temp_max: "err"
      },
      weather: [{ description: "err" }]
    }
  }
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    //from sagas/db on INIT
    case ACTIONS.INIT_DEMO: {
      return {
        ...state,
        data: { ...action.payload }
      };
    }

    case ACTIONS.FETCH_WEATHER: {
      return {
        ...state,
        weather: { ...state.weather, data: action.payload }
      };
    }

    case ACTIONS.GENERATE_DATA: {
      return {
        ...state,
        data: { ...action.payload }
      };
    }

    case ACTIONS.STORE_DATA: {
      return {
        ...state,
        data: action.payload
      };
    }

    default: {
      return state;
    }
  }
};

export default dataReducer;



// WEBPACK FOOTER //
// ./src/reducers/dataReducer.js